import { PageRoute } from "..";
import { FC } from "react";
import { useSelector } from "react-redux";
import { Switch } from "react-router-dom";

import { selectIsAdmin } from "store/entities/agents";
import {
  selectHasDoneLiveChatSelectiveImportBefore,
  selectLiveChatFullImportNotPerformed,
} from "store/entities/integrations";

import { WelcomeTutorialRoutes } from "./helpers";
import { ImportDataStep } from "./livechat-steps/ImportDataStep";
import ManageEmailsStep from "./livechat-steps/ManageEmailsStep";
import ManageableTicketsStep from "./livechat-steps/ManageableTicketsStep";
import TicketFormStep from "./livechat-steps/TicketFormStep";

export const LcIntegrationTutorial: FC = () => {
  const isOwner = useSelector(selectIsAdmin);
  const hasNotPerformFullImportBefore = useSelector(selectLiveChatFullImportNotPerformed);
  const hasEverDoneSelectiveImport = useSelector(selectHasDoneLiveChatSelectiveImportBefore);

  const shouldDisplayImportDataStep = isOwner && hasNotPerformFullImportBefore && !hasEverDoneSelectiveImport;

  return (
    <Switch>
      <PageRoute
        exact
        path={WelcomeTutorialRoutes.LC_MANAGE_EMAILS}
        documentTitle="Manage all emails from customers in HelpDesk"
      >
        <ManageEmailsStep />
      </PageRoute>
      <PageRoute
        exact
        path={WelcomeTutorialRoutes.LC_TICKET_FORM}
        documentTitle="Support customers even when you're away"
      >
        <TicketFormStep />
      </PageRoute>
      <PageRoute
        exact
        path={WelcomeTutorialRoutes.LC_MANAGEABLE_TICKETS}
        documentTitle="Create manageable tickets directly from chats"
      >
        <ManageableTicketsStep shouldDisplayImportDataStep={shouldDisplayImportDataStep} />
      </PageRoute>
      {shouldDisplayImportDataStep && (
        <PageRoute exact path={WelcomeTutorialRoutes.LC_IMPORT_DATA} documentTitle="Import data from LiveChat">
          <ImportDataStep />
        </PageRoute>
      )}
    </Switch>
  );
};
